<template>
  <div class="MainMenu lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="MainMenu-topCurve-wrapper lxn-w100">
      <CustomCurve>
      </CustomCurve>
    </div>
    <div class="MainMenu-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg @click="enterHiddenMode++" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 250 250"><path d="M46.055-.256h158.75c25.2 0 45.62 20.43 45.62 45.62v158.75c0 25.2-20.43 45.62-45.62 45.62H46.055c-25.2 0-45.62-20.43-45.62-45.62V45.364c-.01-25.2 20.42-45.62 45.62-45.62z" fill="#ececec"/><path d="M215.635 224.754s-34.57 6.3-90.2 6.3-90.2-6.3-90.2-6.3a9.81 9.81 0 0 1-9.81-9.81s-6.3-34.57-6.3-90.2 6.3-90.2 6.3-90.2a9.81 9.81 0 0 1 9.81-9.81s34.57-6.3 90.2-6.3 90.2 6.3 90.2 6.3a9.81 9.81 0 0 1 9.81 9.81s6.3 34.57 6.3 90.2-6.3 90.2-6.3 90.2a9.81 9.81 0 0 1-9.81 9.81z" fill="#53636c"/><path d="M104.9 124.82a17.94 17.94 0 0 0 17.94 17.94c2.9 0 5.66-.7 8.1-1.93v40.7h-16.17l-6.5-13.74-5.5-2.28-14.3 5.12-11.44-11.44 5.12-14.3-2.28-5.5-13.74-6.5v-16.17l13.74-6.5 2.28-5.5-5.12-14.3L88.46 79l14.32 5.12 5.48-2.27 6.5-13.75h16.17v40.7c-2.43-1.24-5.18-1.93-8.1-1.93a17.94 17.94 0 0 0-17.94 17.94z" fill="#3bb878"/><g fill="#fff"><path d="M136.03 67.95h3.34V83.4h-3.34zm22.27 0h3.34V83.4h-3.34zm-12.54 0l-2.3 2.3v10.8l2.3 2.3h6.13l2.3-2.3v-10.8l-2.3-2.3h-6.13zm5.1 11.74l-.36.36h-3.36l-.36-.36v-8.05l.36-.36h3.36l.36.36v8.05zm.01 7.2h3.34v15.44h-3.34zm29.67 19.1h3.34v15.44h-3.34zm-29.67 0h3.34v15.44h-3.34zm7.43 0h3.34v15.44h-3.34zm14.82-19.1h3.34v15.44h-3.34z"/><use xlink:href="#B"/><path d="M144.48 121.32l2.3-2.3v-10.8l-2.3-2.3h-6.13l-2.3 2.3V119l2.3 2.3h6.13zm-5.1-11.74l.36-.36h3.36l.36.36v8.05l-.36.36h-3.36l-.36-.36v-8.05zm28.64-3.7l-2.3 2.3V119l2.3 2.3h6.13l2.3-2.3v-10.8l-2.3-2.3h-6.13zm5.1 11.75l-.36.36h-3.36l-.36-.36v-8.05l.36-.36h3.36l.36.36v8.05z"/><use xlink:href="#B" x="22.25"/><path d="M158.3 165.94h3.34v15.44h-3.34zm-7.43 0h3.34v15.44h-3.34z"/><use xlink:href="#C"/><path d="M150.87 146.97h3.34v15.44h-3.34zm29.67-19.07h3.34v15.44h-3.34zm-44.5 0h3.34v15.44h-3.34zm22.27 0h3.34v15.44h-3.34zm14.82 19.07h3.34v15.44h-3.34z"/><use xlink:href="#C" y="-18.97"/><use xlink:href="#C" x="29.67" y="-37.94"/><use xlink:href="#C" x="7.41" y="-37.94"/><use xlink:href="#C" x="22.25" y="-18.97"/></g><defs ><path id="B" d="M144.48 102.35l2.3-2.3v-10.8l-2.3-2.3h-6.13l-2.3 2.3v10.8l2.3 2.3h6.13zm-5.1-11.74l.36-.36h3.36l.36.36v8.05l-.36.36h-3.36l-.36-.36V90.6z"/><path id="C" d="M138.35 165.94l-2.3 2.3v10.8l2.3 2.3h6.13l2.3-2.3v-10.8l-2.3-2.3h-6.13zm5.1 11.75l-.36.36h-3.36l-.36-.36v-8.05l.36-.36h3.36l.36.36v8.05z"/></defs></svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.MainMenu_title}}
        </template>
        <template v-slot:text>
          <div class="MainMenu-button lxn-margin-auto lxn-w100">
            <div class="lxn-title lxn-text-en lxn-text-center">
              V {{appVersion}}
            </div>
          </div>
          <div class="MainMenu-button lxn-margin-auto lxn-w100">
            <div class="lxn-title lxn-text-en lxn-text-center">
               {{phonenumber}}
            </div>
          </div>
          
          <div class="MainMenu-button lxn-margin-auto lxn-w100">
            <CustomButton @click="$router.push('/LanguageSelect/')" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
              {{$store.getters.language.texts.MainMenu_button1}}
            </CustomButton>
          </div>
          <div class="MainMenu-button lxn-margin-auto lxn-w100">
            <CustomButton @click="$router.push('/LogOut/')" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
              {{$store.getters.language.texts.MainMenu_button2}}
            </CustomButton>
          </div>
        </template>
      </WrapperSvgTitleText>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import * as CONFIGS from '@/statics/configs.js'


export default {
  name: 'MainMenu',
  components: {
    CustomCurve,
    WrapperSvgTitleText,
    CustomButton
  },
  data() {
    return {
      enterHiddenMode: 0,
    }
  },
  watch: {
    enterHiddenMode: function (newVal) {
      if(newVal == 3){
        this.$router.push('/parameterSetter')
      }
    }
  },
  computed: {
    appVersion: function () {
      return CONFIGS.APP_VERSION;
    },
    phonenumber : function () {
      return this.$store.getters.getPhoneNumber
    }
  },
  methods: {
    next: function () {
      this.$router.push('/AddNewDevice');
    },
    next2: function () {
      this.$router.push('/HubLogin');
    }
  }
}
</script>

<style>
  .MainMenu-topCurve-wrapper {
    height: 200px;
  }
  .MainMenu-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .MainMenu-button {
    margin-bottom: 14px;
  }
  .MainMenu-button:first-child {
    margin-top: 14px;
  }
</style>
